import { Outlet, useLocation, useNavigation } from 'react-router';
import { ScrollRestoration } from 'react-router-dom';
import { ChakraProvider, Box } from '@chakra-ui/react';
import { AuthProvider } from '@lib/auth';
import { UserProvider } from '@lib/userProvider';
import theme from '@cmp/theme';
import Fonts from '@cmp/fonts';
import Loader from '@cmp/loader';
import { WpProvider } from '@cmp/buttons/buttonWhatsappProvider';

import '@/App.css';
import { useEffect } from 'react';
import { LANDING, EXCHANGE_CODES } from '@routes';

const initialDate = new Date(2025, 9, 15, 7, 45, 0, 0);

export const App = () => {
  const location = useLocation();
  const navigation = useNavigation();
  const isLoading = navigation.state === 'loading';
  const isLanding = location.pathname === LANDING;
  const hasBlur = false;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  if (initialDate > new Date() && import.meta.env.VITE_SHOW_LOADER === 'true') {
    return (
      <Loader flexDir={'column-reverse'} color={'#333'} hasAnimation={false}>
        <Box>
          <b style={{ display: 'block' }}>Volvió la Promo que pone a soñar a los colombianos.</b>
          <i>Fecha y hora de inicio: 15 de Octubre de 2025 a las 8:00am.</i>
        </Box>
      </Loader>
    );
  }

  return (
    <>
      <ScrollRestoration getKey={(location) => location.pathname} />
      <ChakraProvider theme={theme}>
        <Fonts />
        <AuthProvider>
          <UserProvider>
            <WpProvider>
              <Outlet />

              {!isLanding && !isLoading && location.pathname !== EXCHANGE_CODES && (
                <Box position={'relative'}>
                  <Box
                    background={hasBlur ? 'rgba(255, 255, 255, 0.20)' : 'unset'}
                    backdropFilter={hasBlur ? 'blur(15px)' : 'unset'}
                    zIndex={location.pathname === '/home' ? 2 : 10}
                    position={'fixed'}
                    w={'100vw'}
                    bottom={'0%'}
                    pointerEvents={'none'}
                  >
                    <Box
                      w={'100%'}
                      px={{ base: '15px', md: '150px' }}
                      display={'flex'}
                      justifyContent={'flex-end'}
                      py={'12px'}
                      pointerEvents={'none'}
                    ></Box>
                  </Box>
                </Box>
              )}
              {isLoading && <Loader m={0} zIndex={1001} position={'fixed'} top={0} left={0} w={'100vw'} h={'100vh'} />}
            </WpProvider>
          </UserProvider>
        </AuthProvider>
      </ChakraProvider>
    </>
  );
};
